<ng-template rt-connected-overlay hasBackdrop [origin]="origin()" (backdropClick)="toggleOverlay()">
  <rt-dropdown [width]="DropdownWidth.LargeXX">
    <rt-dropdown-item [hasHoverEffect]="false" (click)="$event.stopImmediatePropagation()">
      <rt-heading variant="heading semi-bold">
        {{ 'app.stages.candidate_anonymization.learn_more.heading' | translate }}
      </rt-heading>
      <ul>
        <li>
          {{
            'app.stages.candidate_anonymization.learn_more.enabled_for_stage'
              | translate: { stage: anonymousStage().name }
          }}
        </li>
        <li>
          {{
            'app.stages.candidate_anonymization.learn_more.cant_see_until_next_stage' | translate
          }}
        </li>
        <li>
          {{ 'app.stages.candidate_anonymization.learn_more.team_members_can_reveal' | translate }}
        </li>
      </ul>
    </rt-dropdown-item>
    <rt-dropdown-item
      hrefTarget="_blank"
      [href]="'app.support_resources.anonymous_candidates' | translate"
      [noDivider]="true"
      (click)="$event.stopImmediatePropagation()"
    >
      {{ 'app.common.learn_more' | translate }}
      <rt-icon name="open-in-new" suffix></rt-icon>
    </rt-dropdown-item>
  </rt-dropdown>
</ng-template>
